/**
 * Date Utility Functions
 *
 * Pure functions for date conversion (no Vue dependencies).
 * Use these in transformers, repositories, and other non-component modules.
 *
 * IMPORTANT: These are pure utilities, NOT Vue composables.
 * For component use, see useDateFormatter composable.
 */

export function parseApiDateTime(isoString: string | null | undefined): Date | null {
  if (!isoString) return null
  const date = new Date(isoString)
  return isNaN(date.getTime()) ? null : date
}

export function parseApiDate(dateString: string | null | undefined): Date | null {
  if (!dateString) return null
  const [year, month, day] = dateString.split('-').map(Number)
  const date = new Date(year, month - 1, day, 12, 0, 0)
  return isNaN(date.getTime()) ? null : date
}

export function toApiDateTime(date: Date | null | undefined): string | null {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) return null
  return date.toISOString()
}

export function toApiDate(date: Date | null | undefined): string | null {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) return null
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
